import type { Method } from 'lib/axios';
import { APICallV3Post, APICallV4 } from 'reactApp/api/APICall';
import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { CloudActions } from 'reactApp/constants/cloudActions';

const method = 'document/create';
export class CreateDocAPICallV3 extends APICallV3Post {
    _method = method;
    _headers = { 'X-VFS-Action': CloudActions.FILE_CREATE };
}

export class CreateDocAPICallV4 extends APICallV4 {
    _method = method;
    _type: Method = 'post';
    _headers = { 'X-VFS-Action': CloudActions.FILE_CREATE };
}

export const getCreateDocAPICall = () => (IS_B2B_BIZ_USER ? new CreateDocAPICallV4() : new CreateDocAPICallV3());
